import { render, staticRenderFns } from "./ResultIcon.vue?vue&type=template&id=365e2f14"
import script from "./ResultIcon.vue?vue&type=script&lang=js"
export * from "./ResultIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports